import React, { useCallback, useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

type UserLocationState = {
  lat: number;
  lng: number;
} | null;


export const useUserLocation = ({ setViewState, onError }: { setViewState: (updater: any) => void; onError?: (err: GeolocationPositionError) => void }) => {

      const [userLocation, setUserLocation] = useState<UserLocationState>(() => {
        try {
        //   const raw = window.localStorage.getItem('floodnet_user_location');
        //   if (!raw) return null;
        //   const parsed = JSON.parse(raw);
        //   if (parsed && typeof parsed.lat === 'number' && typeof parsed.lng === 'number') {
        //     return { lat: parsed.lat, lng: parsed.lng };
        //   }
        } catch {
          // ignore
        }
        return null;
      });
    
      useEffect(() => {
        if (!userLocation) return;
        try {
          window.localStorage.setItem('floodnet_user_location', JSON.stringify(userLocation));
        } catch {
          // ignore
        }
      }, [userLocation]);
    
      const [error, setError] = useState<string | null>(null);

      const requestUserLocation = useCallback(() => {
        console.log('Requesting user location...');
        console.log('navigator.geolocation', navigator.geolocation);
        if (!('geolocation' in navigator)) return;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const { latitude, longitude } = pos.coords;
            const loc = { lat: latitude, lng: longitude };
            console.log('Got user location:', loc);
            setUserLocation(loc);
            setViewState(prev => ({
                ...(prev || {}),
                latitude: loc.lat,
                longitude: loc.lng,
                zoom: 15 + (Math.random() + 1)*0.01,
            }));
            // Fly to user immediately on successful button-triggered location
            // setInitialViewState((prev) => ({
            //   ...(prev || DEFAULT_VIEW),
            //   latitude: loc.lat,
            //   longitude: loc.lng,
            //   zoom: Math.max((prev?.zoom ?? DEFAULT_VIEW.zoom), 15),
            // }));
          },
          (error) => {
            console.error('Error getting user location', error);
            setError(error?.message || 'Unable to fetch location');
            onError?.(error);
          },
          { enableHighAccuracy: true, maximumAge: 60000, timeout: 10000 },
        );
      }, [setViewState, onError]);
    return { userLocation, requestUserLocation, setUserLocation, error };
};


export const CurrentLocationButton = ({ requestUserLocation }: { requestUserLocation: () => void }) => {
    return (
        <Tooltip title="Where am I?">
            <IconButton size="small" onClick={requestUserLocation} aria-label="locate-me">
                <MyLocationIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    )
};

export const CurrentLocationMarker = React.memo(({ userLocation }: { userLocation: UserLocationState }) => {
    return (
        userLocation && (
          <AdvancedMarker position={{ lat: userLocation.lat, lng: userLocation.lng }} zIndex={100}>
            <div
              style={{
                position: 'relative',
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'rgba(51, 136, 255, 0.9)',
                boxShadow: '0 0 0 4px rgba(51, 136, 255, 0.25)',
                border: '1.5px solid white',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: -8,
                  borderRadius: '50%',
                  border: '2px solid rgba(51, 136, 255, 0.6)',
                  animation: 'floodnet-pulse 2.4s infinite',
                }}
              />
            </div>
          </AdvancedMarker>
        )
    )
});
